module.exports = __webpack_public_path__ + "img/green-certificate-and-seed.ec7f9573.webp";